import React, { useContext } from "react";

import ElementContext from "../ElementContext";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "./tagline.module.less";

export function Tagline({
    children,
    taglineClass,
    hasLightBackground
}) {
    const { isLightBg } = useContext(ElementContext);
    const backgroundIsLight = hasLightBackground ?? isLightBg ?? true;

    return (
        <span
            className={gcs(
                taglineClass,
                styles.tagline,
                !backgroundIsLight ? styles.lightColor : ""
            )}
        >
            {children}
        </span>
    );
}
